﻿
import { ISingleEpletMmRisk } from '@nkr/models/index';
export interface ICenterBillingReport {
    rank: number,
    transplantDate: string,
    micrositeActivationDate: string,
    micrositeWtMonths: number,
    swapType: string,
    chainId: number,
    cluster: number,
    position: number,
    donorId: number,
    organType: number,
    invoiceDate: string,
    donorCenterId: number,
    donorCenter: string,
    remoteDonorCenterId: number,
    remoteDonorCenterAlias: string,
    donorAlias: string,
    donorRelationship: string,
    recipientId: number,
    recipientCenterId: number,
    recipientCenter: string,
    recipientAlias: string,
    recipientWasIncompatiblePair: boolean,
    shipMethod: string,
    transportVendor: string,
    transportCost: number,
    donorType: string,
    evalBilled: boolean,
    evalAmount: number,
    recipientType: string,
    isCompatible: boolean,
    isCompatiblePairCpr: boolean,
    isMicrositeFacilitated: boolean,
    hasMsFeeWaiver: boolean,
    micrositeRecipientId: number,
    recipientBloodType: string,
    recipientHasMedicareAb: boolean,
    donorBloodType: string,
    intendedDonorAlias: string,
    intendedDonorAbo: string,
    isTransplanted: boolean,
    recipientCpra4: number
    waitTimeInMonths: number,
    waitTimeInYears: number,
    evalBilledCenter: string,
    activeStarterSite: boolean,
    activeCustomSite: boolean,
    singleEpletMmRisk: ISingleEpletMmRisk,
    bmtMm: number,
    donor: any,
    recipient: any,
    donorFlagLdPrioritization: boolean,
    donorFlags: string[]
}